import { chakra } from '@chakra-ui/react';

import config from 'configs/app';
import { useAppContext } from 'lib/contexts/app';
import * as cookies from 'lib/cookies';

const TextAd = () => {
  const hasAdblockCookie = cookies.get(
    cookies.NAMES.ADBLOCK_DETECTED,
    useAppContext().cookies,
  );

  if (!config.features.adsText.isEnabled || hasAdblockCookie === 'true') {
    return null;
  }

  return null;
};

export default chakra(TextAd);
